import PaginationItem from '@mui/material/PaginationItem';
export default PaginationItem;
export * from '@mui/material/PaginationItem';
